module.exports = __webpack_public_path__ + "img/BNT.04a9dea4.svg";